<script setup lang="ts">
import { ref, defineProps, computed } from "vue";

defineProps<{
  color:
    | "pink"
    | "blue"
    | "purple"
    | "orange"
    | "green"
    | "black"
    | "asphalt"
    | "fog";
  text?: string;
}>();

const tagContent = ref<HTMLElement>();
const textFixed = ref<HTMLElement>();

const isHovered = ref(false);

const onMouseOver = () => {
  const sw = textFixed.value?.scrollWidth || 0;
  const ow = textFixed.value?.offsetWidth || 0;
  isHovered.value = isHovered.value || Number(sw) > Number(ow);
};

const onMouseLeave = () => {
  isHovered.value = false;
};

const transformProperty = computed(() => {
  const calc =
    Number(isHovered.value) &&
    `calc(${Number(textFixed.value?.offsetWidth)}px - 100%)`;
  return {
    transform: `translateX(${calc})`,
  };
});
</script>

<template>
  <PTag :color="color">
    <div
      ref="tagContent"
      class="tag-content"
      @mouseover="onMouseOver"
      @mouseleave="onMouseLeave"
    >
      <span
        v-if="text"
        ref="textFixed"
        :class="{ 'text-fixed': !isHovered, 'text-scroll': isHovered }"
        :style="transformProperty"
      >
        {{ text }}
      </span>
    </div>
    <template #right>
      <slot name="right" />
    </template>
  </PTag>
</template>

<style scoped>
.tag-content {
  max-width: 100%;
  position: relative;
}
.text-fixed {
  display: block;
  max-width: 352px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-scroll {
  display: inline-flex;
  transition: all 1s linear;
}

.text-scroll:hover {
  transform: translateX(calc(330px - 100%));
}
</style>
